export interface StrapiImage {
  url?: string | null
  alternativeText?: string | null
}

export type ReferralFormProgram = {
  index: number
  ProgramID: number
  ProgramName: string
  ProgramType: string
  Specialization: string
  Custom10PgType: string | null
}

export interface RewardCard {
  Heading?: string | null
  SubHeading?: string | null
  Description?: string | null
  Price?: string | null
  BorderColor?: string | null
  BackgroundColor?: string | null
  Icon?: StrapiImage | null
}

export interface RewardsSubListItem {
  Text?: string | null
  Icon?: StrapiImage | null
}

export interface BenefitCard {
  Heading?: string | null
  Description?: string | null
  BorderColor?: string | null
  HeadingIcon?: StrapiImage | null
  Icon?: StrapiImage | null
}

export interface BadgeItem {
  Name?: string | null
  Icon?: StrapiImage | null
}

export interface ExperientialItem {
  Heading?: string | null
  BorderColor?: string | null
  Icon?: StrapiImage | null
  BackgroundColor?: string | null
  SubHeading?: string | null
}

export interface AmbassadorItem {
  Name?: string | null
  Text?: string | null
  Image?: StrapiImage | null
}

export interface FaqItem {
  question?: string | null
  answer?: string | null
  type?: string | null
  id?: string | null
}

export interface ReferralData {
  ReferralBanner?: {
    BackgroundImage?: StrapiImage | null
  } | null
  ReferralRewards?: {
    RewardsHeading?: string | null
    RewardSubHeading?: string | null
    RewardCards?: RewardCard[] | null
    RewardsSubList?: RewardsSubListItem[] | null
  } | null
  ReferralBenefit?: {
    Heading?: string | null
    SubHeading?: string | null
    ReferralBenefitCard?: BenefitCard[] | null
  } | null
  ReferralNoticedReward?: {
    Heading?: string | null
    SubHeading?: string | null
    LeaderBoard?: { Heading?: string | null; Icon?: StrapiImage | null } | null
    MilestoneBadges?: {
      Heading?: string | null
      Description?: string | null
      Icon?: StrapiImage | null
      BadgesList?: BadgeItem[] | null
    } | null
  } | null
  ExperientialReward?: {
    Heading?: string | null
    SubHeading?: string | null
    ExperientialRewardList?: ExperientialItem[] | null
  } | null
  AmbassadorsReferral?: {
    Heading?: string | null
    SubHeading?: string | null
    AmbassadorsReferralList?: AmbassadorItem[] | null
  } | null
  FAQ?: {
    Enabled?: boolean | null
    FAQitems?: FaqItem[] | null
  } | null
  seo?: {
    metaTitle?: string | null
    metaDescription?: string | null
    keywords?: string | null
    canonicalURL?: string | null
    metaRobots?: string | null
    metaImage?: StrapiImage | null
  } | null
}

export function mediaUrl(img?: StrapiImage | null): string | undefined {
  const url = img?.url
  if (!url) return undefined
  if (url.startsWith('http')) return url
  const base = process.env.NEXT_PUBLIC_NEW_IMAGE_PATH || ''
  return `${base}${url.replace(/^\//, '')}`
}
